import { Container, SelectList } from "./style";

function ChainSelectDropdown({ assetChain, setAssetChain }: any) {
  return (
    <Container>
      <SelectList
        value={assetChain}
        onChange={(event) => {
          setAssetChain(event.target.value);
        }}
      >
        <option value="">--Please choose your asset chain--</option>
        <option value="ETH">ETH</option>
        <option value="POLYGON">POLYGON</option>
      </SelectList>
    </Container>
  );
}

export default ChainSelectDropdown;
